<template>
  <div class="choose-device">
    <Modal :value="visible" :title="title" :width="modalWidth" @on-cancel="onCancel">
      <template v-if="!showSelectedData">
        <Row :gutter="10">
          <Col span="4">
            <Select
              placeholder="所属系统"
              @on-change="onChangeSystem"
              @on-open-change="onSelectSysOpen"
              v-model="searchSys"
            >
              <Option v-for="item in opts" :value="item.value" :key="item.value">{{ item.label }}</Option>
            </Select>
          </Col>
          <Col span="4">
            <Select placeholder="设备属性" @on-change="onChangeAttr" v-model="searchAttr">
              <Option v-for="item in attrOpt" :value="item.value" :key="item.value">{{ item.label }}</Option>
            </Select>
          </Col>
          <Col span="6">
            <Input v-model="searchKeyword" search @on-enter="searchByKeyword" />
          </Col>
        </Row>
        <Row :gutter="10" style="margin-top: 10px">
          <Col span="6">
            <div class="col-1">
              <Tabs value="name1" name="choose-device">
                <TabPane label="按位置" name="name1" tab="choose-device">
                  <span>全部</span>
                  <Tree :data="systemTreeData" @on-select-change="onSystemTreeChange"></Tree>
                </TabPane>
                <TabPane label="按类型" name="name2" tab="choose-device">
                  <span>全部</span>
                  <Tree :data="typeTreeData"  @on-select-change="onTypeTreeChange"></Tree>
                </TabPane>
              </Tabs>
            </div>
          </Col>
          <Col span="18">
            <Table
              v-if="!multiple"
              :height="tableHeight"
              :columns="columnsRadio"
              :data="tableData"
              highlight-row
            >
            <template slot-scope="{ row, index }" slot="action">
                <Radio :value="row._checked" @on-change="onRadioTableChange(index)" />
            </template>
            </Table>
            <Table
              v-else
              :height="tableHeight"
              :columns="columns"
              :data="tableData"
              @on-select-all="onSelectAll"
              @on-select="onSelect"
              @on-select-cancel="onSelectCancel"
              @on-select-all-cancel="onSelectAllCancel"
            ></Table>
          </Col>
        </Row>
      </template>
      <template v-else>
        <Table
          :height="tableHeight"
          :columns="columns"
          @on-select="onSelectionsTableSelect"
          @on-select-all="onSelectionsTableSelectAll"
          @on-select-all-cancel="onSelectionsTableSelectAllCancel"
          @on-select-cancel="onSelectionsTableSelectCancel"
          :data="selections"
        ></Table>
      </template>

      <div class="u-modal-wrapper" slot="footer">
        <Button type="text" v-if="multiple" class="expand-btn" @click="toggleSelectedData">
          {{
          expandText
          }}
        </Button>
        <Button type="primary" @click="onOk">确定</Button>
        <Button @click="onCancel">取消</Button>
      </div>
    </Modal>
  </div>
</template>

<script>
// import { deepCopy } from "../../utils/tools";
import {
  // getStoresList,
  getLocation,
  getDeviceType,
  getDeviceList
} from "@/api/components.js";
import { getSystemList } from "@/api/common.js";
export default {
  name: "choose-device",
  created() {
    this.getAjaxData();
    getLocation().then(res => {
      this.systemTreeData = this.formatLocationData(res.data);
    });
    getDeviceType().then(res => {
      this.typeTreeData = this.formatDeviceTypeData(res);
    });
  },
  props: {
    value: {
      type: Boolean,
      default: false
    },
    multiple: {
      type: Boolean,
      default: false
    },
    checkedId: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      tableWidth: 760,
      tableHeight: 400,
      visible: this.value,
      showSelectedData: false,
      searchSys: "",
      searchAttr: "",
      searchKeyword: "",
      checkedData: this.checkedId, //选中是数据id
      selections: [],
      columnsRadio: [
        {
          title: "编号",
          key: "number",
          width: 200
        },
        {
          title: "名称",
          key: "name",
          width: 100
        },
        {
          title: "属性",
          key: "attr"
        },
        {
          title: "所属系统",
          key: "address"
        },
        {
          title: " ",
          slot: "action",
          width: 60,
          align: "center"
        }
      ],
      columns: [
        {
          title: "编号",
          key: "number",
          width: 200
        },
        {
          title: "名称",
          key: "name",
          width: 100
        },
        {
          title: "属性",
          key: "attr"
        },
        {
          title: "所属系统",
          key: "address"
        },
        {
          type: "selection",
          width: 60,
          align: "center"
        }
      ],
      tableData: [], //列表数据
      ajaxData: [], //ajax数据
      rebuildData: [],
      opts: [],
      attrOpt: [
        {
          value: 1,
          label: "设备"
        },
        {
          value: 2,
          label: "计量表"
        },
        {
          value: 3,
          label: "设施"
        }
      ],
      systemTreeData: [],
      typeTreeData: []
    };
  },
  mounted() {
    // this.rebuildData = this.tableData;
  },
  updated() {
    //todo 点击已选，关闭弹窗，再次显示弹窗，table宽度渲染不正确
  },
  computed: {
    modalWidth() {
      return 1040;
    },
    checkedIdArr() {
      return this.selections.filter(item => item._checked).map(item => item.id);
    },
    expandText() {
      if (this.showSelectedData) {
        return "收起";
      } else {
        return `已选${this.selections.length}`;
      }
    },
    title() {
      return this.showSelectedData
        ? `已选${this.checkedIdArr.length}`
        : "选择设备";
    }
  },
  methods: {
    getAjaxData(params = {}) {
      getDeviceList({ ...params })
        .then(res => {
          this.formatData(res.data);
        })
        .catch(err => {
          const { status } = err;
          if (status === "002") {
            this.tableData.splice(0, this.tableData.length);
          }
        });
    },
    formatData(ajaxData) {
      this.tableData.splice(0, this.tableData.length);
      ajaxData.forEach(item => {
        this.tableData.push({
          id: item.id,
          name: item.name,
          number: item.code_number,
          attr: item.attribute_name,
          system: "",
          _checked: this.checkedIdArr.indexOf(item.id) !== -1,
          _nodeKey: item.id,
          rawData: item
        });
      });
    },
    formatLocationData(data) {
      //整理接口返回的数据
      let res = [];
      // console.log(this.checkedData);
      data.forEach(item => {
        let obj = {
          title: item.place,
          id: item.id
        };
        if (item.lists && item.lists.length) {
          obj.children = this.formatLocationData(item.lists);
        }
        res.push(obj);
      });
      return res;
    },
    formatDeviceTypeData(data) {
      //整理接口返回的数据
      let res = [];
      // console.log(this.checkedData);
      data.forEach(item => {
        let obj = {
          title: item.type_name,
          id: item.id
        };
        if (item.lists && item.lists.length) {
          obj.children = this.formatDeviceTypeData(item.lists);
        }
        res.push(obj);
      });
      return res;
    },
    onRadioTableChange(index) {
      this.tableData.forEach((item, _index) => {
        if(_index === index){
          item._checked = true;
          this.selections.splice(0, 1, item);
        } else {
          item._checked = false;
        }
      })
    },
    onSelectSysOpen(isOpen) {
      if (isOpen && !this.opts.length) {
        getSystemList()
          .then(res => {
            let data = res.data;
            data.forEach(item => {
              this.opts.push({
                value: item.id,
                label: item.type_name
              });
            });
          })
          .catch(err => {
            console.log(err);
          });
      }
    },
    onChangeAttr(val) {
      /* 设备属性变化时 */
      this.getAjaxData({ attribute: val });
    },
    onChangeSystem(val) {
      /* 所属系统发生变化 */
      this.getAjaxData({ device_system_id: val });
    },
    searchByKeyword() {
      /* 关键字搜索 */
      this.getAjaxData({search_name: this.searchKeyword});
    },
    onSystemTreeChange(checkedNodes, current) {
      /* 按位置查找 */
      const { id } = current;
      this.getAjaxData({place_id: id});
    },
    onTypeTreeChange(checkedNodes, current) {
      /* 按类型查找 */
      const { id } = current;
      this.getAjaxData({type_id: id});
    },
    onSelectAll(selection) {
      selection.forEach(item => {
        this.onSelect(selection, item);
      });
    },
    onSelectAllCancel() {
      this.tableData.forEach(item => {
        this.onSelectCancel([], item);
      });
    },
    onSelectCancel(selection, row) {
      const indexOfSelections = this.findIndex(row, this.selections);
      const indexOfTableData = this.findIndex(row, this.tableData);

      row._checked = false;
      this.tableData.splice(indexOfTableData, 1, row);
      this.selections.splice(indexOfSelections, 1);
    },
    onSelect(selection, row) {
      row._checked = true;
      let index = this.findIndex(row, this.tableData);
      this.tableData.splice(index, 1, row);
      this.selections.push(row);
    },
    onSelectionsTableSelectCancel(selection, row) {
      row._checked = false;
      const index = this.findIndex(row, this.selections);
      const indexOfTableData = this.findIndex(row, this.tableData);
      this.selections.splice(index, 1, row);
      this.tableData.splice(indexOfTableData, 1, row);
    },
    onSelectionsTableSelect(selection, row) {
      row._checked = true;
      const index = this.findIndex(row, this.selections);
      const indexOfTableData = this.findIndex(row, this.tableData);
      this.selections.splice(index, 1, row);
      this.tableData.splice(indexOfTableData, 1, row);
    },
    onSelectionsTableSelectAll(selection) {
      selection.forEach(item => {
        this.onSelectionsTableSelect(selection, item);
      });
    },
    onSelectionsTableSelectAllCancel(selection) {
      this.selections.forEach(item => {
        this.onSelectionsTableSelectCancel(selection, item);
      });
    },
    findIndex(target, data = [], targetKey = "id") {
      let key = target[targetKey];
      let index = -1;
      for (let i = 0; i < data.length; i++) {
        if (data[i][targetKey] === key) {
          index = i;
        }
      }
      return index;
    },
    toggleSelectedData() {
      //显示/隐藏已选数据
      if (!this.showSelectedData && this.selections.length === 0) {
        this.$Message.warning({
          content: "未选择任何数据"
        });
        return;
      }
      if (this.showSelectedData) {
        this.selections = this.selections.filter(item => item._checked);
      }
      this.showSelectedData = !this.showSelectedData;
    },
    onOk() {
      this.$emit("on-ok", this.selections);
      this.close();
    },
    onCancel() {
      this.close();
    },
    close() {
      this.visible = false;
      this.$emit("on-close");
      this.$emit("input", false);
    }
  },
  watch: {
    checkedId() {
      this.checkedData = this.checkedId;
      this.tableData = this.formatData(this.ajaxData);
    },
    value() {
      this.visible = this.value;
    }
  }
};
</script>

<style type="text/css" scoped lang="less">
.col-1 {
  .ivu-tabs-tabpane {
    height: 345px;
    overflow: auto;
  }
  border: 1px solid #e1e3e5;
}
</style>
